module.exports = __webpack_public_path__ + "static/media/m2.29e30ef8.png";